module.exports = __webpack_public_path__ + "img/生长动画.73da98e1.gif";